module.exports = __webpack_public_path__ + "large_question_bank.svg?f12cf9492e820da974f7ca860a4165e5";


//////////////////
// WEBPACK FOOTER
// ./static/large_question_bank.svg
// module id = 38
// module chunks = 0